import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from 'react-query';
import { mapAddOnToAddOnItem } from '../utils';
import { AddOn, AddOnItem } from '~/types/models/addon';
import axios, { AxiosError } from 'axios';
import { BillingCycle } from '~/types/models';

const { team } = window.Bonjoro;

export const queryKeys = {
  detail: ['add-ons', 'detail'] as const,
};

export interface GetAddOnResponse {
  data: AddOn[];
}

export async function getAddOn() {
  const res = await axios.get<GetAddOnResponse>(
    `/api/v3/teams/${team.id}/addons`
  );
  return res.data.data;
}

export interface UseAddOnsParams {
  options?: UseQueryOptions<AddOnItem[], AxiosError>;
}

export function useAddOns({ options }: UseAddOnsParams) {
  const getAddOnsList = async () => {
    const response = await getAddOn();

    return mapAddOnToAddOnItem(response);
  };

  return useQuery<AddOnItem[], AxiosError>(
    queryKeys.detail,
    getAddOnsList,
    options
  );
}

export interface CancelAddOnArgs {
  teamId: string;
  addOnUuid: string;
}

export interface CancelAddOnResponse {
  message: string;
}

export async function cancelAddOnArgs({ teamId, addOnUuid }: CancelAddOnArgs) {
  const res = await axios.delete<CancelAddOnResponse>(
    `/api/v3/teams/${teamId}/addons/${addOnUuid}`
  );
  return res.data;
}

export interface UseCancelAddOnParams extends CancelAddOnArgs {
  options?: UseMutationOptions<CancelAddOnResponse, AxiosError>;
}

export function useCancelAddOn({
  teamId,
  addOnUuid,
  options,
}: UseCancelAddOnParams) {
  return useMutation<CancelAddOnResponse, AxiosError>(
    queryKeys.detail,
    () => cancelAddOnArgs({ teamId, addOnUuid }),
    options
  );
}

type GetAddOnMonthlyPriceArgs = {
  price: number;
  billingCycle: BillingCycle;
};

export const getAddOnMonthlyPrice = ({
  price,
  billingCycle,
}: GetAddOnMonthlyPriceArgs): string => {
  const monthlyPrice =
    billingCycle === BillingCycle.Yearly ? price / 12 : price;
  return monthlyPrice % 1 === 0 ? `${monthlyPrice}` : monthlyPrice.toFixed(2);
};
